import React from 'react';

type JourneyInputVariant = 'default' | 'money';

export interface JourneySelectOption {
  label: React.ReactNode;
  value: string | number;
  disabled?: boolean;
}

export interface JourneySelectInputProps
  extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'children'> {
  options?: JourneySelectOption[];
  placeholder?: string;
  hasError?: boolean;
  variant?: JourneyInputVariant;
  children?: React.ReactNode;
}

function cx(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(' ');
}

export const JourneySelectInput: React.FC<JourneySelectInputProps> = ({
  options = [],
  placeholder,
  className,
  hasError = false,
  variant = 'default',
  children,
  ...props
}) => {
  const variantClassName =
    variant === 'money'
      ? cx('money-form-field__control', 'money-form-field__control--select')
      : '';

  return (
    <select
      {...props}
      className={cx(
        variantClassName,
        variant === 'money' && hasError && 'is-error',
        className,
      )}
    >
      {placeholder ? <option value="">{placeholder}</option> : null}
      {options.map((option) => (
        <option
          key={`${option.value}`}
          value={option.value}
          disabled={option.disabled}
        >
          {option.label}
        </option>
      ))}
      {children}
    </select>
  );
};

export const SelectInput = JourneySelectInput;

export default JourneySelectInput;
